<template>
  <Container type="card-full">
    <vggrid ref="xGrid" :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pInviteIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          // { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectno', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'psubmcheckusername', fieldtype: 'C', title: '邀请人',calculExpr:'',addNewRowFlg: false},
          { field: 'psubmchecktime', fieldtype: 'C', title: '受邀时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: '', fieldtype: 'C', title: '通过人',calculExpr:'',addNewRowFlg: false},
          { field: '', fieldtype: 'C', title: '通过时间',calculExpr:'',addNewRowFlg: false},
          // { field: 'psustatus', fieldtype: 'C', title: '已报名/已确认/已报价/已评分',calculExpr:'',addNewRowFlg: false}
        ],
        psu: {},
        query: {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('CONFIRM', () => this.batchConfirm())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async viewProject(row) {
        this.$router.push({name: 'pInviteInfo', params: {form: row.row, type: 1}})
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.psu = {}
      },
      async batchConfirm(row) {
        let selectRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        console.log(row)
        let model = {
          userid: this.$store.getters.loginUser.userid,

        }
        let data = await request({
          url: '/xmgl/project/savePsuConfirm',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.getPageList()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.psu = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },

      async getPageList () {
        console.log(this.query)
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuInviteConfirmList',
          params: this.query
        })
        this.list = res
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
